import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Input, Form, Label, Spinner, Button } from "reactstrap";
import { updateProfile } from "../../../../actions/customer";
import {
  authKey_local_storage_key,
  userInfo_local_storage_key,
} from "../../../../helpers/common";
import ImageUploader from "../../../../helpers/Common/ImageUploader";
import { CustomSnackbar } from "../../../../helpers/CustomSnackbar";
import ChangeLoginFieldModal from "../../../../helpers/Common/ChangeLoginFieldModal";

const UpdateProfile = () => {
  const { profile } = useSelector((state) => state.customer);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem(authKey_local_storage_key);

  // Change login field states
  const [openChangeEmailModal, setOpenChangeEmailModal] = useState(false);
  const [openChangeMobileModal, setOpenChangeMobileModal] = useState(false);

  const additional_fields = profile?.additional_fields
    ? JSON.parse(profile?.additional_fields)
    : {};

  const [formData, setFormData] = useState({
    name: profile.name,
    email: profile.email,
    mobile_number: profile.mobile_number,
    username: profile.username,
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onNumberInputChange = (e) => {
    const inputValue = e.target.value;

    if (!inputValue) {
      setFormData({ ...formData, [e.target.name]: "" });
      return;
    }

    if (!/^\d+$/.test(inputValue)) return;
    setFormData({ ...formData, [e.target.name]: parseInt(inputValue) });
  };

  // Change login field handlers
  const handleChangeEmail = () => {
    setOpenChangeEmailModal(true);
  };

  const handleChangeMobile = () => {
    setOpenChangeMobileModal(true);
  };

  const handleEmailChangeSuccess = (newEmail) => {
    setFormData({ ...formData, email: newEmail });
    CustomSnackbar.success("Email updated successfully!");
  };

  const handleMobileChangeSuccess = (newMobile) => {
    setFormData({ ...formData, mobile_number: newMobile });
    CustomSnackbar.success("Mobile number updated successfully!");
  };

  const updateProfileHandle = (newProfilePic) => {
    const payload = {
      ...formData,
      AdditionalFields: {
        profile_picture: newProfilePic ?? additional_fields?.profile_picture,
      },
    };

    dispatch(updateProfile({ ...payload, id: profile.id })).then((res) => {
      setLoading(false);

      if (res.status === 200 && res.data.id) {
        CustomSnackbar.success(
          `Profile ${newProfilePic ? "picture" : ""} updated successfully.`
        );

        const customer = res.data;

        localStorage.setItem(
          userInfo_local_storage_key,
          JSON.stringify({ customer, token })
        );
      }
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!formData.name) {
      CustomSnackbar.error("Please enter your name");
      return;
    }

    // Since email and mobile are changed through modals, we don't need to validate them here
    // The modals handle their own validation

    setLoading(true);
    updateProfileHandle();
  };

  return (
    <>
      <Form onSubmit={onSubmit}>
        <ImageUploader
          uploadPath="/customers/attachment"
          assetType="customers"
          updateImageHandle={updateProfileHandle}
          imageName={additional_fields?.profile_picture}
        />
  
        <Row>
          <Col lg={12}>
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">
                Full Name *
              </label>
              <Input
                name="name"
                value={formData.name}
                type="text"
                className="form-control"
                onChange={onChange}
                id="fullName"
                placeholder="Enter your full name"
              />
            </div>
          </Col>
  
          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="mobile_number" className="form-label">
                Mobile Number *
              </Label>
              <div className="d-flex">
                <Input
                  name="mobile_number"
                  type="text"
                  value={formData.mobile_number}
                  className="form-control"
                  onChange={onNumberInputChange}
                  id="mobile_number"
                  maxLength={10}
                  placeholder="Enter your mobile number"
                  disabled
                />
                <Button
                  color="outline-primary"
                  size="sm"
                  className="profile-edit-btn"
                  onClick={handleChangeMobile}
                  title="Change Mobile Number"
                >
                  <i className="uil uil-pen"></i>
                </Button>
              </div>
            </div>
          </Col>
  
          <Col lg={6}>
            <div className="mb-3">
              <Label htmlFor="email" className="form-label">
                Email *
              </Label>
              <div className="d-flex">
                <Input
                  name="email"
                  type="text"
                  value={formData.email}
                  className="form-control"
                  onChange={onChange}
                  id="email"
                  placeholder="Enter your email address"
                  disabled
                />
                <Button
                  color="outline-primary"
                  size="sm"
                  className="profile-edit-btn"
                  onClick={handleChangeEmail}
                  title="Change Email"
                >
                  <i className="uil uil-pen"></i>
                </Button>
              </div>
            </div>
          </Col>
        </Row>
  
        <div className="mt-4 text-end">
          {loading ? (
            <button type="button" className="btn btn-primary disabled w-100">
              Update <Spinner size="sm" />
            </button>
          ) : (
            <button type="submit" className="btn btn-primary w-100">
              Update
            </button>
          )}
        </div>
  
      </Form>
      
        {/* Change Login Field Modals */}
        <ChangeLoginFieldModal
          openModal={openChangeEmailModal}
          setOpenModal={setOpenChangeEmailModal}
          field="email"
          currentValue={formData.email}
          onSuccess={handleEmailChangeSuccess}
        />
  
        <ChangeLoginFieldModal
          openModal={openChangeMobileModal}
          setOpenModal={setOpenChangeMobileModal}
          field="mobile_number"
          currentValue={formData.mobile_number}
          onSuccess={handleMobileChangeSuccess}
        />
    </>
  );
};

export default UpdateProfile;
